/**
 * util to tell whether an element is visible in the window
 * @param element - element to test
 */
export const isInViewport = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

/**
 * Verify if the referrer is external
 * @param {*} referrer
 * @param {*} host
 * @returns
 */
export const isExternalReferrer = (referrer: string, host: string) =>
  referrer ? !referrer.split('//').pop().startsWith(host) : true;

export const navigateTo = (url: string) => {
  window.location.href = url
}
